import { render, staticRenderFns } from "./AppFixedMenu.vue?vue&type=template&id=124bbf2c&scoped=true&"
import script from "./AppFixedMenu.vue?vue&type=script&lang=js&"
export * from "./AppFixedMenu.vue?vue&type=script&lang=js&"
import style0 from "./AppFixedMenu.vue?vue&type=style&index=0&id=124bbf2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124bbf2c",
  null
  
)

export default component.exports